import React from 'react';
import { TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface DataCardProps {
  title: string;
  value: string;
  change: string;
  isNegative?: boolean;
  icon: React.ReactNode;
}
export const DataCard: React.FC<DataCardProps> = ({
  title,
  value,
  change,
  isNegative = false,
  icon
}) => {
  return <div className="bg-white p-4 rounded-lg shadow" data-id="element-116">
      <div className="flex justify-between items-start" data-id="element-117">
        <div data-id="element-118">
          <p className="text-sm text-gray-500" data-id="element-119">{title}</p>
          <p className="text-2xl font-bold mt-1" data-id="element-120">{value}</p>
        </div>
        <div className="p-2 rounded-full bg-gray-50" data-id="element-121">{icon}</div>
      </div>
      <div className={`flex items-center mt-2 ${isNegative ? 'text-red-500' : 'text-green-500'}`} data-id="element-122">
        {isNegative ? <TrendingDownIcon className="h-4 w-4 mr-1" data-id="element-123" /> : <TrendingUpIcon className="h-4 w-4 mr-1" data-id="element-124" />}
        <span className="text-sm font-medium" data-id="element-125">{change}</span>
        <span className="text-xs text-gray-500 ml-1" data-id="element-126">vs last month</span>
      </div>
    </div>;
};